import { NavLink } from "react-router-dom";
import { ChevronRight } from "lucide-react";

function Breadcumbs({ content }) {
  return (
    <div className="pt-8 w-[90%] mx-auto">
      <div className="inline-flex items-center text-m text-gray-600 gap-2 breadcumbs">
        <NavLink to="/" className="hover:text-gray-900 transition-colors">
          Inicio
        </NavLink>

        <ChevronRight size={16} className="text-gray-400" />

        <span className="text-gray-800 font-medium">{content}</span>
      </div>
    </div>
  );
}

export default Breadcumbs;
